/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductDocumentDto } from './ProductDocumentDto';
import {
    ProductDocumentDtoFromJSON,
    ProductDocumentDtoFromJSONTyped,
    ProductDocumentDtoToJSON,
    ProductDocumentDtoToJSONTyped,
} from './ProductDocumentDto';
import type { ProductOwnerDto } from './ProductOwnerDto';
import {
    ProductOwnerDtoFromJSON,
    ProductOwnerDtoFromJSONTyped,
    ProductOwnerDtoToJSON,
    ProductOwnerDtoToJSONTyped,
} from './ProductOwnerDto';
import type { ProductCoverageDto } from './ProductCoverageDto';
import {
    ProductCoverageDtoFromJSON,
    ProductCoverageDtoFromJSONTyped,
    ProductCoverageDtoToJSON,
    ProductCoverageDtoToJSONTyped,
} from './ProductCoverageDto';

/**
 * Product information for broker view
 * @export
 * @interface BrokerProductDto
 */
export interface BrokerProductDto {
    /**
     * Unique identifier of the product
     * @type {string}
     * @memberof BrokerProductDto
     */
    id: string;
    /**
     * Product code
     * @type {string}
     * @memberof BrokerProductDto
     */
    code: string;
    /**
     * Product label/name
     * @type {string}
     * @memberof BrokerProductDto
     */
    label: string;
    /**
     * Short description of the product
     * @type {string}
     * @memberof BrokerProductDto
     */
    summary?: string | null;
    /**
     * Full description of the product
     * @type {string}
     * @memberof BrokerProductDto
     */
    fullDescription?: string | null;
    /**
     * Branch code
     * @type {string}
     * @memberof BrokerProductDto
     */
    branchCode?: string | null;
    /**
     * Branch label
     * @type {string}
     * @memberof BrokerProductDto
     */
    branchLabel?: string | null;
    /**
     * URL of the product logo
     * @type {string}
     * @memberof BrokerProductDto
     */
    logoUrl?: string | null;
    /**
     * 
     * @type {ProductOwnerDto}
     * @memberof BrokerProductDto
     */
    owner?: ProductOwnerDto;
    /**
     * List of product coverages/guarantees
     * @type {Array<ProductCoverageDto>}
     * @memberof BrokerProductDto
     */
    coverages?: Array<ProductCoverageDto>;
    /**
     * List of product documents
     * @type {Array<ProductDocumentDto>}
     * @memberof BrokerProductDto
     */
    documents?: Array<ProductDocumentDto>;
}

/**
 * Check if a given object implements the BrokerProductDto interface.
 */
export function instanceOfBrokerProductDto(value: object): value is BrokerProductDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function BrokerProductDtoFromJSON(json: any): BrokerProductDto {
    return BrokerProductDtoFromJSONTyped(json, false);
}

export function BrokerProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerProductDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'label': json['label'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'fullDescription': json['fullDescription'] == null ? undefined : json['fullDescription'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'branchLabel': json['branchLabel'] == null ? undefined : json['branchLabel'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'owner': json['owner'] == null ? undefined : ProductOwnerDtoFromJSON(json['owner']),
        'coverages': json['coverages'] == null ? undefined : ((json['coverages'] as Array<any>).map(ProductCoverageDtoFromJSON)),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(ProductDocumentDtoFromJSON)),
    };
}

export function BrokerProductDtoToJSON(json: any): BrokerProductDto {
    return BrokerProductDtoToJSONTyped(json, false);
}

export function BrokerProductDtoToJSONTyped(value?: BrokerProductDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'summary': value['summary'],
        'fullDescription': value['fullDescription'],
        'branchCode': value['branchCode'],
        'branchLabel': value['branchLabel'],
        'logoUrl': value['logoUrl'],
        'owner': ProductOwnerDtoToJSON(value['owner']),
        'coverages': value['coverages'] == null ? undefined : ((value['coverages'] as Array<any>).map(ProductCoverageDtoToJSON)),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(ProductDocumentDtoToJSON)),
    };
}

